var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1864 7.62207C25.1864 7.62207 24.4817 7.99754 24.4442 8.18527C23.2427 14.4932 19.6671 16.2238 14.2979 16.2238L11.557 16.1804C10.8811 16.1804 9.95717 17.1215 9.84455 17.7597L8.42775 26.0088L8.81599 26.6584L8.44053 29.2115C8.36541 29.587 8.62826 29.9625 9.04129 30H13.9974C14.5606 30 15.0487 29.587 15.1614 29.0238L15.199 28.7609L16.1001 22.9787C16.2058 22.3007 16.5801 21.7021 17.3391 21.7021H18.0525C22.7458 21.7021 26.4255 19.7872 27.5143 14.2678C27.9649 11.9775 27.7396 10.025 26.5381 8.67336C26.1627 8.22277 25.7121 7.88486 25.1864 7.62207Z",
    fill: "#009BD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0065 6.40182C22.8235 6.02037 21.5389 5.97021 20.3051 5.97021H12.9834C12.4202 5.97021 11.4351 6.71113 11.3225 7.27434L9.66309 17.4592L10.2425 17.7595C10.3551 17.1212 10.9183 16.6331 11.5566 16.6331H14.2975C19.6667 16.6331 23.8483 14.4629 25.0874 8.155C25.1249 7.96727 25.1477 7.82646 25.1861 7.62186C25.1861 7.62186 24.7929 6.73709 24.472 6.57355C24.3194 6.50962 24.1641 6.45232 24.0065 6.40182Z",
    fill: "#192A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8565 7.65955C11.9316 7.09635 12.4197 6.68332 13.0205 6.68332H20.3046C21.1681 6.68332 21.9942 6.75844 22.7076 6.87105C23.1956 6.94617 23.6838 7.05879 24.1719 7.20896C24.5473 7.32158 24.8853 7.47182 25.1857 7.62199C25.5611 5.29406 25.1857 3.71713 23.9091 2.25275C22.5574 0.67582 20.0417 0 16.8127 0H7.50108C6.86276 0 6.29955 0.488086 6.18694 1.12641L2.28201 25.7572C2.2069 26.2078 2.50731 26.6207 2.95783 26.6583H8.81516L10.2795 17.4969L11.8565 7.65955Z",
    fill: "#0A3B82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypal-icon.2f83135fda6d15386d700d13668e42a3.svg";
export { ForwardRef as ReactComponent };